import { ApiService } from '../ApiService';
import type { Message, Conversation } from '../../../types/chat';
import type { ApiResponse } from '../types';

export interface ChatMessageRequest {
  content: string;
  conversationId?: string;
  attachments?: Array<{
    name: string;
    type: string;
    content: string;
  }>;
}

export interface ChatConversationsResponse {
  conversations: Conversation[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPages: number;
  };
}

export const chatApi = {
  // Messages
  sendMessage: (request: ChatMessageRequest): Promise<ApiResponse<Message>> => 
    ApiService.post<Message>('/chat/messages', request),

  // Conversations
  getConversations: (params?: { page?: number; pageSize?: number }): Promise<ApiResponse<ChatConversationsResponse>> => 
    ApiService.get<ChatConversationsResponse>('/chat/conversations', params),

  getConversationById: (id: string): Promise<ApiResponse<Conversation>> => 
    ApiService.get<Conversation>(`/chat/conversations/${id}`),

  deleteConversation: (id: string): Promise<ApiResponse<void>> => 
    ApiService.delete<void>(`/chat/conversations/${id}`),
    
  // Feedback sur les messages
  rateMessage: (messageId: string, rating: { likes?: number; dislikes?: number }): Promise<ApiResponse<Message>> => 
    ApiService.post<Message>(`/chat/messages/${messageId}/rate`, rating),
  
  // Modèles d'IA disponibles
  getAvailableModels: (): Promise<ApiResponse<{ models: Array<{id: string; name: string; description: string }> }>> => 
    ApiService.get<{ models: Array<{id: string; name: string; description: string }> }>('/chat/models')
};
